<div class="notifs" data-test-id="notification-actions-list">
  @for (notif of notifications$ | async; track notif) {
    <app-notification
      class="notif-container flex flex-col gap-4"
      [notification]="notif"
      (archiveNotification)="archiveNotification($event)"
      (routeAction)="routeAction($event)"
    ></app-notification>
  }
</div>
